import { render, staticRenderFns } from "./Processing.vue?vue&type=template&id=f22ccca4&scoped=true&"
var script = {}
import style0 from "./Processing.vue?vue&type=style&index=0&id=f22ccca4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f22ccca4",
  null
  
)

export default component.exports